import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const ACCOUNT_USER_COUNT_QUERY_KEY = 'account-user-count-key';

export function useAccountUserCount({
	accountId,
	enabled = true,
	meta,
}: {
	accountId: string;
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () =>
			new Promise<number>((resolve, reject) =>
				userSession.webServiceHelper.callWebServiceWithOperationResults<number>(
					`account/${accountId}/userCount`,
					'GET',
					null,
					opResult => {
						resolve(opResult.value);
					},
					opResult => {
						reject(opResult);
					}
				)
			),
		queryKey: [ACCOUNT_USER_COUNT_QUERY_KEY, accountId],
		meta,
	});
}

export const invalidateAccountUserCount = (accountId: string) => {
	reactQueryClient.invalidateQueries({ queryKey: [ACCOUNT_USER_COUNT_QUERY_KEY, accountId] });
};
